import { Box, styled, TextField, Button } from "@mui/material";
import TextView from "../../TextView";
import { useFormikContext } from "formik";
import { ButtonLoader } from "../../inputs.styled";

const InfoContainer = styled(Box)(({ theme }) => ({
  borderRadius: "8px",
  border: "1px solid #e1e1e1",
  padding: "16px",
  backgroundColor: "#F6F7F9",
  display: "flex",
  flexDirection: "column",
  gap: "8px",
}));

const FinalReportForm = ({ path, apiLoading }) => {
  const { values, handleChange, handleSubmit } = useFormikContext();

  console.log(values, "kaka");

  const mainCategory = path[0];
  const subCategories = path.slice(1);
  return (
    <>
      {mainCategory && (
        <InfoContainer>
          <TextView variant="subtitle" style={{ color: "#94a1b1" }}>
            Why are you reporting this post?
          </TextView>
          <TextView variant="title" style={{ color: "#123051" }}>
            {mainCategory.name}
          </TextView>
        </InfoContainer>
      )}

      {subCategories.length > 0 && (
        <InfoContainer>
          <TextView variant="subtitle" style={{ color: "#94a1b1" }}>
            Which best describes the problem?
          </TextView>
          <TextView variant="title" style={{ color: "#123051" }}>
            {subCategories.map((node, index) => (
              <span key={node.id}>
                {node.name}
                {index < subCategories.length - 1 && <br />}
              </span>
            ))}
          </TextView>
        </InfoContainer>
      )}

      <TextView variant="subtitle" style={{ color: "#123051" }}>
        Details <span style={{ color: "#94a1b1" }}>(optional)</span>
      </TextView>

      <Box sx={{ position: "relative" }}>
        <TextField
          multiline
          maxRows={5}
          minRows={5}
          fullWidth
          variant="outlined"
          name="details"
          value={values.details}
          onChange={handleChange}
          placeholder="Give us more details about what is wrong with this post..."
          InputProps={{
            style: {
              borderRadius: "8px",
              border: "1px solid #123051",
              padding: "16px",
            },
          }}
          inputProps={{
            maxLength: 500,
          }}
        />

        <Box
          sx={{
            textAlign: "right",
            color: values.details.length === 500 ? "red" : "#94a1b1",
            fontSize: "12px",
            marginTop: "4px",
          }}
        >
          {values.details.length}/500
        </Box>
      </Box>

      <Button
        variant="contained"
        fullWidth
        sx={{
          backgroundColor: "#9B5AF8",
          textTransform: "none",
          borderRadius: "4px",
          transition: "all 0.3s",

          "&:hover": {
            backgroundColor: "#9B5AF8",
            boxShadow: "0 0 5px rgba(0, 0, 0, 0.6)",
            scale: 1.03,
            transition: "all 0.3s",
          },
        }}
        onClick={handleSubmit}
      >
        {apiLoading && <ButtonLoader />} Submit
      </Button>
    </>
  );
};

export default FinalReportForm;
